import React from 'react';
import { FormControlLabel, Switch, Box } from '@mui/material';

export default function ContentSafetySwitch({
  value,
  onChange,
  disabled = false,
}) {
  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={Boolean(value)}
            onChange={(e) => onChange(e.target.checked)}
            name='content_safety'
            disabled={disabled}
          />
        }
        label='Content Safety'
      />
    </Box>
  );
}
